import { UnwrapRef, computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import './index.less';
import addIcon from './icon/add.png';
import editIcon from './icon/edit.png';
import deleteIcon from './icon/delete.png';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { Plugin } from '@vue/runtime-dom';
export const PropertyEidtable = defineComponent({
  props: {
    dataSource: {
      type: Object as PropType<any[]>,
      default: undefined,
    },
    selectItems: {
      type: Object as PropType<any[]>,
    },
    canSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    scrollY: {
      type: String,
      required: false,
      default: '250px',
    },
  },
  emits: ['update:dataSource', 'update:selectItems', 'save', 'change'],
  setup(props, { emit }) {
    const dataSource = ref<any[]>([]);
    const selectKeys = ref<string[]>([]);
    const columns = [
      {
        title: '属性名称',
        dataIndex: 'key',
        width: '30%',
        ellipsis: true,
      },
      {
        title: '属性值',
        dataIndex: 'value',
        width: '50%',
      },
    ];
    const editableData: UnwrapRef<Record<string, any>> = reactive({});

    const refresh = () => {
      dataSource.value = props.dataSource
        ? props.dataSource?.map((x, index) => ({ ...x, showMenu: false, index }))
        : [];
    };

    watch(
      () => props.dataSource,
      () => {
        refresh();
      }
    );

    const scrollYValue = computed(() => {
      if (props.scrollY) {
        return props.scrollY;
      }
      return '250px';
    });

    onMounted(() => {
      refresh();
    });

    const save = async () => {
      emit('update:dataSource', dataSource.value);
      emit('save');
      clearEditableData();
    };

    const add = async () => {
      const record = {
        key: '属性名称',
        value: '属性值',
        index: dataSource.value.length,
      };
      for (let i = 0; i < 10000; i++) {
        record.key = `属性名称${i === 0 ? '' : i}`;
        if (dataSource.value.findIndex((item) => item.key === record.key) === -1) {
          break;
        }
      }
      dataSource.value.push(record);
      await save();
      emit('change', { type: 'add', record: dataSource.value[dataSource.value.length - 1] });
    };

    const modify = async (key: any) => {
      const newVal = { ...editableData[key] };
      if (dataSource.value.find((item) => item.key === newVal.key && item.index !== newVal.index)) {
        message.error('属性名称已存在');
      } else {
        Object.assign(dataSource.value.filter((item) => key === item.key)[0], newVal);
        await save();
        emit('change', { type: 'update', record: newVal });
        updateSelectItem();
      }
      delete editableData[key];
    };

    const deleteItem = async (key: any) => {
      const item = dataSource.value.find((item) => item.key === key);
      dataSource.value = dataSource.value.filter((item) => item.key !== key);
      await save();
      emit('change', { type: 'delete', record: item });
      if (props.canSelect) {
        selectKeys.value = selectKeys.value.filter((item) => item !== key);
      }
    };

    /**
     * 清空编辑状态
     */
    const clearEditableData = () => {
      Object.keys(editableData).forEach((key) => {
        delete editableData[key];
      });
    };
    const rowSelection = ref({
      onChange: (keys: string[], _: any[]) => {
        selectKeys.value = [...keys];
        updateSelectItem();
      },
      // selectedRowKeys: selectKeys.value,
    });
    const checkAll = () => {
      selectKeys.value = dataSource.value.map((item) => item.key);
    };

    watch(
      () => selectKeys.value,
      () => {
        updateSelectItem();
      }
    );

    const updateSelectItem = () => {
      if (props.canSelect) {
        emit(
          'update:selectItems',
          dataSource.value.filter((item) => selectKeys.value.includes(item.key))
        );
      }
    };

    return {
      columns,
      // eslint-disable-next-line vue/no-dupe-keys
      dataSource,
      rowSelection,
      editableData,
      add,
      modify,
      deleteItem,
      clearEditableData,
      checkAll,
      scrollYValue,
      refresh,
    };
  },
  render() {
    return (
      <a-table
        class="partName-table"
        rowKey="key"
        columns={this.columns}
        dataSource={this.dataSource}
        size="small"
        rowSelection={this.canSelect ? this.rowSelection : null}
        pagination={false}
        v-slots={{
          headerCell: (record) => {
            if (record.column.dataIndex === 'value') {
              return (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{record.title}</span>
                  <div>
                    <img
                      src={addIcon}
                      style={{ display: 'inline-block' }}
                      onClick={async () => {
                        await this.add();
                      }}
                    />
                  </div>
                </div>
              );
            }
          },
          bodyCell: ({ text, record, _, column }) => {
            if (column.dataIndex === 'key') {
              if (this.editableData[record.key]) {
                return (
                  <a-input
                    value={this.editableData[record.key].key}
                    onChange={(e) => {
                      this.editableData[record.key].key = e.target.value;
                    }}
                    onPressEnter={async () => {
                      this.modify(record.key);
                    }}
                  />
                );
              }
              return <>{text || ' '}</>;
            }
            if (column.dataIndex === 'value') {
              if (this.editableData[record.key]) {
                return (
                  <a-input
                    value={this.editableData[record.key].value}
                    onChange={(e) => {
                      this.editableData[record.key].value = e.target.value;
                    }}
                    onPressEnter={async () => {
                      this.modify(record.key);
                    }}
                  />
                );
              }
              return (
                <div
                  class="edit-value"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {text || ' '}
                  </span>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      class="edit-icon"
                      src={editIcon}
                      onClick={(e) => {
                        this.clearEditableData();
                        this.editableData[record.key] = cloneDeep(
                          this.dataSource.filter((item) => record.key === item.key)[0]
                        );
                        e.stopPropagation();
                      }}
                      style={{
                        visibility: record.showMenu ? 'visible' : 'hidden',
                        width: '20px',
                      }}
                    />
                    <img
                      class="delete-icon"
                      src={deleteIcon}
                      v-show={record.showMenu}
                      onClick={async (e) => {
                        this.clearEditableData();
                        await this.deleteItem(record.key);
                        e.stopPropagation();
                      }}
                      style={{
                        width: '20px',
                      }}
                    />
                  </div>
                </div>
              );
            }
          },
        }}
        customRow={(record) => {
          return {
            onMouseenter: () => {
              record.showMenu = true;
            }, // 鼠标移入行
            onMouseleave: () => {
              record.showMenu = false;
            }, // 鼠标移出行
            onClick: async () => {
              if (!this.editableData[record.key]) {
                Object.keys(this.editableData).forEach(async (key) => {
                  await this.modify(key);
                });
              }
            },
          };
        }}
        scroll={{ y: this.scrollYValue }}
      ></a-table>
    );
  },
});

export const DPropertyEidtable: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DPropertyEidtable', PropertyEidtable);
  },
};
